import {
  GET_MY_PROFILE,
} from './types';
import { SetRegValueHelper, SpreadOps } from '../helper';

const initialState = {
  myProfile: {},
};

var temp = "";
initialState.values = SpreadOps({ ...initialState.default });

export default function (state = initialState, action) {
  switch (action.type) {

    case GET_MY_PROFILE:
      return {
        ...state,
        myProfile: action.data,
      }

    default:
      return state

  }
}
